export const backUrl = "https://lolliadminpanel.buzz/api/";
